<div class="fill-comments-popup" (click)="close()">
    <div class="fill-comments-dialog" (click)="$event.stopPropagation()">
        <div class="fill-comments-header">
            <div class="fill-comments-title-section">
                <h4>User Input Datafields</h4>
                <p class="fill-comments-subtext">Given below are User-Input datafields. Please enter the required information ensuring the data is complete, accurate, and up to date.</p>
            </div>
            <button class="fill-comments-close" (click)="close()" [disabled]="saving" title="Close">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div class="fill-comments-body">
            <div class="fill-comments-loading" *ngIf="loading">
                <div class="spinner-small"></div>
                <p>Loading schema records...</p>
            </div>

            <div class="fill-comments-sections" *ngIf="!loading">
                <div class="fill-comments-schema" *ngFor="let schema of schemas; let schemaIndex = index">
                    <div class="fill-comments-schema-header">
                        <h5>{{ schemaIndex + 1 }}. {{ schema.displayName }}</h5>
                        <button class="fill-comments-view-toggle"
                                *ngIf="!schema.error && schema.rows.length > 0"
                                (click)="toggleRecordsView(schemaIndex)"
                                [title]="isRecordsVisible(schemaIndex) ? 'Hide records' : 'Show records'">
                            <span class="material-icons">{{ isRecordsVisible(schemaIndex) ? 'visibility' : 'visibility_off' }}</span>
                        </button>
                    </div>

                    <p class="fill-comments-error" *ngIf="schema.error">{{ schema.error }}</p>

                    <div class="fill-comments-no-records" *ngIf="!schema.error && schema.rows.length === 0">
                        No records found.
                    </div>

                    <!-- VIEW MODE: Read-only records table (horizontal scroll) -->
                    <div class="fill-comments-view-mode" *ngIf="!schema.error && schema.rows.length > 0 && isRecordsVisible(schemaIndex)">
                        <div class="records-table-wrapper">
                            <table class="records-table">
                                <thead>
                                    <tr>
                                        <th class="record-id-col">Record</th>
                                        <th *ngFor="let key of schema.displayKeys" [title]="getDisplayLabel(key)">{{ getDisplayLabel(key) }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of schema.rows; let rowIndex = index">
                                        <td class="record-id-col">{{ rowIndex + 1 }}</td>
                                        <td *ngFor="let key of schema.displayKeys" [title]="row.displayValues[key] ?? '-'">
                                            {{ row.displayValues[key] ?? '-' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- EDIT MODE: Records Table (Compact Format) -->
                    <div class="fill-comments-edit-mode" *ngIf="!schema.error && schema.rows.length > 0 && !isRecordsVisible(schemaIndex)">
                        <div class="edit-table-wrapper">
                            <table class="edit-records-table">
                                <thead>
                                    <tr>
                                        <th class="pk-column">{{ getPrimaryKeyLabel(schemaIndex) }}</th>
                                        <th *ngFor="let field of schema.fields">{{ getFieldLabelFromMapping(schemaIndex, field.key, field.label) }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of schema.rows; let rowIndex = index">
                                        <td class="pk-column pk-value" [title]="getPrimaryKeyValue(schemaIndex, row)">{{ getPrimaryKeyValue(schemaIndex, row) }}</td>
                                        <td *ngFor="let field of schema.fields">
                                            <input
                                                [type]="getInputType(field.type)"
                                                [value]="row.editableValues[field.key] ?? ''"
                                                (input)="onFieldChange(schemaIndex, rowIndex, field.key, $event.target.value)"
                                                [step]="field.type === 'int' ? '1' : null"
                                                [placeholder]="getFieldPlaceholder(getFieldLabelFromMapping(schemaIndex, field.key, field.label))"
                                                [title]="row.editableValues[field.key] || 'Empty'"
                                                [disabled]="saving"
                                                class="edit-field-input" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fill-comments-footer">
            <button class="fill-comments-btn fill-comments-cancel" (click)="close()" [disabled]="saving">
                Cancel
            </button>
            <button class="fill-comments-btn fill-comments-add"
                    (click)="confirmAndProceed()"
                    [disabled]="loading || saving"
                    title="Review fields and proceed with bulk ingest">
                <span class="spinner-mini" *ngIf="saving"></span>
                {{ saving ? 'Processing...' : 'Confirm & Proceed' }}
            </button>
        </div>
    </div>
</div>
